import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../setup'
import { initializeWebSocket } from '../modules/components/WebSocket/InitializeWebSocket'
import ExtrernalUrls from '../modules/external/ExtrernalUrls'
import UsersPage from '../modules/user/UsersPage'
import {useIntl} from 'react-intl'

const PrivateRoutes = () => {
  const accessToken: any = useSelector<RootState>(({ auth }) => auth.accessToken, shallowEqual)
  const customerId: any = useSelector<RootState>(({ auth }) => auth.userId, shallowEqual)
  const dispatch = useDispatch()
  const customer: any = useSelector<RootState>(
    ({ device }) => device.customer,
    shallowEqual
  )
  const intl = useIntl()
  const webSocketRef = React.useRef<{ disconnect: () => void } | null>(null)

  React.useEffect(() => {
    if (accessToken && customerId) {
      const SOCKET_URL = process.env.REACT_APP_SOCKET_URL as string

      webSocketRef.current = initializeWebSocket({
        customerId,
        accessToken,
        SOCKET_URL,
        intl,
        // onMessageReceived: handleMessage,
        // onConnect: handleConnect,
        // onDisconnect: handleDisconnect,
        dispatch,
      })
    } else if (webSocketRef.current) {
      webSocketRef.current.disconnect()
      webSocketRef.current = null
    }

    return () => {
      if (webSocketRef.current) {
        webSocketRef.current.disconnect()
        webSocketRef.current = null
      }
    }
  }, [customerId, accessToken])

  const DevicesPage = lazy(() => import('../modules/device/DevicesPage'))
  const DashboardWrapper = lazy(() => import('../pages/dashboard/DashboardWrapper'))

  const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {maintenanceMode != 'true' ||
          (maintenanceMode == 'true' && localStorage.getItem('maintenanceMode') == 'true') ? (
          <>
            <Route path="/" element={<Navigate to='/devices' replace />} />

            <Route path='/dashboard/*'
              element={
                <SuspensedView>
                  <DashboardWrapper />
                </SuspensedView>
              } />

            <Route path='auth/*' element={<Navigate to='/devices' />} />

            <Route
              path='/devices/*'
              element={
                <SuspensedView>
                  <DevicesPage />
                </SuspensedView>
              }
            />

            <Route
              path='/user/*'
              element={
                <SuspensedView>
                  <UsersPage />
                </SuspensedView>
              }
            />

            <Route path='/other-info' element={
              <SuspensedView>
                <ExtrernalUrls url={customer.InfoUrl} />
              </SuspensedView>
            } />

            <Route path='*' element={<Navigate to='/error/404' />} />
          </>
        ) : (
          <>
            <Route path='*' element={<Navigate to='/maintenance' />} />
          </>
        )}
      </Route>
    </Routes>
  )
}

const SuspensedView: FC = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
